(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ViewCounter", [], factory);
	else if(typeof exports === 'object')
		exports["ViewCounter"] = factory();
	else
		root["ViewCounter"] = factory();
})(self, () => {
return 